export default function () {
  const route = useRoute()
  const path = computed(() => route?.path || window.location.pathname)

  const isHomePage = computed(() => {
    return /^\/(app)?(\/)?$/.test(path.value)
  })

  const isAccountMainPage = computed(() => {
    return /^\/(app\/)?account(\/)?$/.test(path.value)
  })

  const isAccountOrdersPage = computed(() => {
    return /^\/(app\/)?account\/orders(\/)?$/.test(path.value)
  })

  const isAccountSetupPage = computed(() => {
    return /^\/(app\/)?account\/setup(\/)?$/.test(path.value)
  })

  const isAccountWalletPage = computed(() => {
    return /^\/(app\/)?account\/wallet(\/)?$/.test(path.value)
  })

  const isAccountWatchlistPage = computed(() => {
    return /^\/(app\/)?account\/watchlist(\/)?$/.test(path.value)
  })

  const isAuthPage = computed(() => {
    return /^\/auth(\/)?$/.test(path.value)
  })

  const isEmailLinkAuthPage = computed(() => {
    return /^\/__\/auth\/action\/.+?$/.test(path.value)
  })

  const isCartPage = computed(() => {
    return /^\/(app\/)?cart(\/)?$/.test(path.value)
  })

  const isCheckoutPage = computed(() => {
    return /^\/(app\/)?checkout(\/)?$/.test(path.value)
  })

  const isOrderDetailPage = computed(() => {
    return /^\/(app\/)?order\/.+$/.test(path.value)
  })

  const isProductPage = computed(() => {
    return /\/product\/.+$/.test(path.value)
  })

  const isRetailerSetupPage = computed(() => {
    return /^\/(app\/)?r\/setup(\/chat)?(\/)?$/.test(path.value)
  })

  const isSearchPage = computed(() => {
    return /^\/(app\/)?(p\/.*?\/)?search(\/)?$/.test(path.value)
  })

  // Site Experience Routes
  const isPartnerRoute = computed(() => {
    return /^\/(app\/)?p\/.+$/.test(path.value)
  })
  const isRetailerRoute = computed(() => {
    return /^\/(app\/)?r(\/.*)?$/.test(path.value)
  })
  const isReturnRoute = computed(() => {
    return /^\/app\/return(\/)?/.test(path.value)
  })
  const isShoppingRoute = computed(() => {
    return /^\/(app\/)?shop(\/)?/.test(path.value) || isHomePage.value || isAccountWatchlistPage.value
  })

  return {
    isAccountMainPage,
    isAccountOrdersPage,
    isAccountSetupPage,
    isAccountWalletPage,
    isAccountWatchlistPage,
    isAuthPage,
    isPartnerRoute,
    isCartPage,
    isCheckoutPage,
    isEmailLinkAuthPage,
    isHomePage,
    isOrderDetailPage,
    isProductPage,
    isRetailerRoute,
    isRetailerSetupPage,
    isReturnRoute,
    isSearchPage,
    isShoppingRoute,
  }
}
